/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import firebase from 'firebase/app';
import config from './config.json';

const localConfig =
  process.env.REACT_APP_ENV === 'production' ? config.prod : config.dev;

const app = firebase.initializeApp(localConfig);

export { firebase as default, app };
